import { post } from 'wtb-utils';

const url = process.env.REACT_APP_API_URL;
const validationServiceUrl = process.env.REACT_APP_VALIDATION_SERVICE_URL;

function getTransactionById(id) {
  return post(`${url}/${id}/resume`);
}

function generatePayment(id, data) {
  return post(`${url}/${id}/start-pay`, data);
}

function continuePay(id, data) {
  return post(`${url}/${id}/continue-pay`, data);
}

function completePay(id, data) {
  return post(`${url}/${id}/complete-pay`, data);
}

function finish(id, data) {
  return post(`${url}/${id}/finish`, data);
}

function cancel(id, data) {
  return post(`${url}/${id}/cancel`, data);
}

function sendDetails(id, details) {
  const {
    nationalId,
    email,
    phone,
    name,
    address
  } = details;

  return post(`${url}/${id}/details`, {
    customer: {
      nationalId
    },
    contact: {
      email,
      phone,
      name,
      address
    }
  });
}

function validateBilling(id, details) {
  return post(`${url}/${id}/validate-pay`, details);
}

function validateEmail(data) {
  return post(`${validationServiceUrl}/validate-email`, data);
}

export {
  cancel,
  completePay,
  continuePay,
  finish,
  getTransactionById,
  generatePayment,
  sendDetails,
  validateBilling,
  validateEmail
};
